module.exports = __webpack_public_path__ + "static/meta-7397c13ea53f75c5c544e1922cdb3af5.png";